import { eventBus, EVENTS } from '../commons/EventBus.js';
import API from "../commons/Api.js";
import {Paginator} from "../commons/paginator.js";
import Utils from "../commons/utils.js";
import router from '../commons/Router.js';


eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
    const template=data.template;

    console.log('EVENTS.PAGE_AFTER_RENDERING - PROFILO');

    if(template == "profilo" && location.pathname.indexOf("profilo") != -1){

        user.checkUser(function (_user){
            Utils.showWaitingLoader();

            // if(_user.has_password == "NO_PWD"){
            //     $("#modifica_password_div").hide();
            // }


            if(!_user.loginmail){
                _user.loginmail = "-";
            }

            if(!_user.email){
                _user.email = "-";
            }


            $("#modifica_password_blocco").hide();
            /* blocco intestazione */

            // $("#immagine_profilo").attr("src", _user.avatar);
            // $("#profilo_nome_cognome").html(_user.nome + " " + _user.cognome);

            var email = _user.loginmail;

            // if(email.indexOf("@") != -1){
                // $("#profilo_mail").html(_user.loginmail);
            // }

            API.get("community/riepilogo_attivita_utente", null, (resp) => {

              var game_type_fanize = resp.game_type_fanize;

              var array_game_type_fanize = [];

              $.each(game_type_fanize, function (index, value) {
                array_game_type_fanize[value.fanize_type] = value.placeholder;
              });

              // /* blocco hai giocato a */
              // API.getOnFanize("campaigns/" + window.campaignId + "/users/mobile/tasks/done", {}, function (respFanize) {
              //
              //   console.log("fanize",respFanize["data"]["done"], resp.giochi);
              //   var fanize=respFanize["data"]["done"];
              //   var new_fanize = [];
              //   for (let i = 0; i < fanize.length; i++) {
              //     fanize[i].post_title = fanize[i].data.title;
              //     fanize[i].punti = fanize[i].data.coins;
              //     fanize[i].image = array_game_type_fanize[fanize[i].type];
              //     new_fanize.push(fanize[i]);
              //   }

                if(resp.status == 0) {
                   // var all_giochi = resp.giochi.concat(new_fanize);
                   var all_giochi = resp.giochi;
                    if(all_giochi.length >0) {


                        let template_giochi = "";

                        $.each(all_giochi, function (index, value) {

                            let tmp = window.templates["blocco_gioco_utente"];
                            template_giochi += tmp.replace("{{post_title}}", value.post_title).replace("{{post_excerpt}}", value.post_excerpt).replace("{{punti}}", value.punti).replace("{{image}}", value.image);

                        });

                        $("#giochi-web-utente").html(template_giochi);

                        const breakpoints_giochi = [
                            {maxWidth: 550, perPage: 1},
                            {maxWidth: 750, perPage: 2},
                            {perPage: 3}
                        ];
                        user.paginatore_giochi = new Paginator($('.pagination_blocco_giochi'), {
                            total: all_giochi.length,
                            breakpoints: breakpoints_giochi,
                            cssVar: '--gu_paginator',
                            swipeElementSelector: '#giochi-web-utente'
                        });

                        $("#giochi-web-utente").fadeIn(500);

                    } else{
                        $("#giochi-web-utente").html(window.templates["empty_state_giochi"]);
                        $("#giochi-web-utente").fadeIn(500);
                    }
                  hideMostraAltri(".pagination_blocco_giochi");

                  /* blocco i tuoi preferiti */

                    // categorie podcat
                    if(resp.podcast_categorie_utente.length > 0) {

                        let template_podcast = "";

                        $.each(resp.podcast_categorie_utente, function (index, value) {

                            let tmp = window.templates["blocco_categorie_utente"];
                            template_podcast += tmp.replace(/{{name}}/g, value.name)
                                .replace("{{img_src}}", value.img_src)
                                .replaceAll("{{element_id}}", value.element_id)
                                .replace("{{link_url}}", value.link_url)

                        });

                        $("#podcast-categorie-utente").html(template_podcast);

                        const breakpoints_categorie = [
                            {maxWidth: 500, perPage: 2},
                            {maxWidth: 700, perPage: 3},
                            {maxWidth: 850, perPage: 4},
                            {maxWidth: 1000, perPage: 5},
                            {perPage: 6}
                        ];

                        user.paginatore_categorie_preferiti = new Paginator($('.pagination_blocco_categorie'), {
                            total: resp.podcast_categorie_utente.length,
                            breakpoints: breakpoints_categorie,
                            cssVar: '--cat_paginator',
                            swipeElementSelector: '#podcast-categorie-utente'
                        });




                        $("#podcast-categorie-utente").fadeIn(500);


                    } else{
                        $("#podcast-categorie-utente").html(window.templates["empty_state_podcast"]);
                        $("#podcast-categorie-utente").fadeIn(500);
                    }

                    hideMostraAltri(".pagination_blocco_categorie");

                    /* podcast */

                    if(resp.podcast_preferiti.length > 0) {

                        let template_podcast = "";

                        $.each(resp.podcast_preferiti, function (index, value) {

                            let tmp = window.templates["blocco_podcast_utente"];
                            template_podcast += tmp.replaceAll("{{post_title}}", value.post_title)
                                .replaceAll("{{img_src}}", value.img_src)
                                .replaceAll("{{audio_src}}", value.audio_src)
                                .replaceAll("{{category}}", value.category)
                                .replaceAll("{{date}}", value.date)
                                .replaceAll("{{post_hour}}", value.post_hour)
                                .replaceAll("{{ID}}", value.id)
                                .replaceAll("{{element_id}}", value.id)
                                .replaceAll("{{share_img}}", value.img_src)
                                .replaceAll("{{share_title}}", value.post_title)
                                .replaceAll("{{share_caption}}", value.category)
                                .replaceAll("{{slug}}", value.slug)
                                .replaceAll("{{share_url}}", value.audio_src);

                        });

                        $("#podcast-utente").html(template_podcast);

                        const breakpoints_podcast = [
                            {maxWidth: 900, perPage: 1},
                            {perPage: 2}
                        ];

                        user.paginatore_podcast_preferiti = new Paginator($('.pagination_blocco_podcast'), {
                            total: resp.podcast_preferiti.length,
                            breakpoints: breakpoints_podcast,
                            cssVar: '--pu_paginator',
                            swipeElementSelector: '#podcast-utente'
                        });

                        $("#podcast-utente").fadeIn(500);

                        $('.profilo-play-icon').click((e) => {
                            const playingClass = 'profilo-playing';
                            const audioSrc = $(e.target).attr('data-audio');
                            console.log(playerPodcast.getSource());
                            console.log(audioSrc);
                            if (playerPodcast.getSource() == audioSrc && playerPodcast.playing()) {
                                playerPodcast.stop();
                                $('.profilo-play').removeClass(playingClass);
                            } else if (playerPodcast.getSource() == audioSrc) {
                                playerPodcast.play();
                            } else {
                                playerPodcast.setSource(audioSrc);
                                playerPodcast.play();
                            }
                        });

                        playerPodcast.on('resume', (a, b, c) => {
                            const playingClass = 'profilo-playing';
                            const playables = $('.profilo-play .profilo-play-icon');
                            $('.profilo-play').removeClass(playingClass);
                            for (let i = 0; i < playables.length; i++) {
                                const playable = playables[i];
                                if ($(playable).attr('data-audio') == playerPodcast.getSource()) {
                                    $(playable).closest('.profilo-play').addClass(playingClass);
                                }
                            }
                        });

                        playerPodcast.on('pause', () => {
                            const playingClass = 'profilo-playing';
                            $('.profilo-play').removeClass(playingClass);
                        });

                    } else{
                        $("#podcast-utente").html(window.templates["empty_state_episodi"]);
                        $("#podcast-utente").fadeIn(500);
                    }

                    hideMostraAltri(".pagination_blocco_podcast");

                    // podcast video
                    if(resp.podcast_video_preferiti.length > 0) {

                        let template_podcast = "";

                        $.each(resp.podcast_video_preferiti, function (index, value) {

                            let tmp = window.templates["blocco_podcast_video_utente"];
                            template_podcast += tmp.replaceAll("{{post_title}}", value.post_title)
                                .replaceAll("{{video_dam}}", value.video_dam)
                                .replaceAll("{{featured_image}}", value.featured_image)
                                .replaceAll("{{date}}", value.date)
                                .replaceAll("{{category}}", value.category)
                                .replaceAll("{{id}}", value.id)

                        });

                        $("#podcast-video-utente").html(template_podcast);

                        const breakpoints_podcast_video = [
                            {maxWidth: 600, perPage: 1},
                            {maxWidth: 1000, perPage: 2},
                            {perPage: 3}
                        ];

                        user.paginatore_podcast_video_preferiti = new Paginator($('.pagination_blocco_podcast_video'), {
                            total: resp.podcast_video_preferiti.length,
                            breakpoints: breakpoints_podcast_video,
                            cssVar: '--pv_paginator',
                            swipeElementSelector: '#podcast-video-utente'
                        });


                        $("#podcast-video-utente").fadeIn(500);


                    } else{
                        $("#podcast-video-utente").html(window.templates["empty_state_video"]);
                        $("#podcast-video-utente").fadeIn(500);
                    }

                    hideMostraAltri(".pagination_blocco_podcast_video");
                    /* canzoni */

                    if(resp.canzoni_preferite.length > 0) {

                        let template_canzoni = "";

                        $.each(resp.canzoni_preferite, function (index, value) {

                            let tmp = window.templates["blocco_canzoni_utente"];
                            template_canzoni += tmp.replaceAll("{{song_img}}", value.song_img)
                                .replaceAll("{{song_title}}", value.song_title)
                                .replaceAll("{{song_artist}}", value.song_artist)
                                .replaceAll("{{track_id}}", value.track_id)
                                .replaceAll("{{data_id}}", value.track_id)
                                .replaceAll("{{song_mdbid}}", value.rds_song_id);

                        });

                        $("#canzoni-utente").html(template_canzoni);

                        const breakpoints_canzoni = [
                            {maxWidth: 500, perPage: 2},
                            {maxWidth: 700, perPage: 3},
                            {maxWidth: 850, perPage: 4},
                            {maxWidth: 1000, perPage: 5},
                            {perPage: 6}
                        ];

                        user.paginatore_canzoni_preferite = new Paginator($('.pagination_blocco_canzoni'), {
                            total: resp.canzoni_preferite.length,
                            breakpoints: breakpoints_canzoni,
                            cssVar: '--cu_paginator',
                            swipeElementSelector: '#canzoni-utente'
                        });


                        $("#canzoni-utente").fadeIn(500);

                    } else{
                        $("#canzoni-utente").html(window.templates["empty_state_canzoni"]);
                        $("#canzoni-utente").fadeIn(500);
                    }
                    hideMostraAltri(".pagination_blocco_canzoni");
                    /* blocco cronologia */
                    //TODO:

                }

            // }, function () {
            //
            // });

                Utils.hideWaitingLoader();


            });

            /* blocco dati personali */

            $("#immagine_profilo_inner").attr("src", _user.avatar);

            populate_profile_fields("blocco_dati_nome", _user.nome);
            populate_profile_fields("blocco_dati_cognome", _user.cognome);
            populate_profile_fields("blocco_dati_email", _user.email);
            populate_profile_fields("blocco_dati_email_old", _user.email);
            populate_profile_fields("blocco_dati_citta", _user.luogo);
            populate_profile_fields("blocco_dati_nascita", _user.nascita);
            populate_profile_fields("blocco_dati_telefono", _user.telefono);
            populate_profile_fields("blocco_dati_indirizzo", _user.indirizzo);
            populate_profile_fields("blocco_dati_cap", _user.cap);
            populate_profile_fields("blocco_dati_luogo_nascita", _user.luogonascita);
            populate_profile_fields("blocco_dati_provincia", _user.provincia);
            populate_profile_fields("blocco_dati_professione", _user.extra.professione);

            if(_user.extra.musica) {
                $("#musica-" + _user.extra.musica.toLowerCase()).addClass("selected");
            }

            if(_user.extra.interessi) {
                $("#interessi-" + _user.extra.interessi.toLowerCase()).addClass("selected");
            }

            $("#profilo_spunta_newsletter").attr("checked",_user.newsletter==1);
            $("#profilo_spunta_privacy_2").attr("checked",_user.p2==1);
            $("#profilo_spunta_privacy_3").attr("checked",_user.p3==1);

            populate_cronologia(_user.userid);

            // RECUPERO COIN / POINTS / PROSSIMO LIVELLO DA FANIZE

            /*
            API.getOnFanize("campaigns/" + window.campaignId + "/users/levels/next", {}, function (resp) {

              // if(resp && resp.data){
              //   var punti_utente = resp.data.points - resp.data.points_to_level;
              //   var punti_utente_perc = Math.round((punti_utente / resp.data.points)*100);
              //   $(".users_level_point").html(resp.data.points);
              //   $(".proper_bar_livello").css("width", punti_utente_perc + "%");
              //   // $(".users_level").html(resp.data.label);
              //   // $("#punti_rimanenti").html(resp.data.points_to_level);
              // }

            }, function () {
              Utils.hideWaitingLoader();
            });
             */

            // RECUPERO PUNTI / COIN DELL'UTENTE

            // API.getOnFanize("campaigns/" + window.campaignId + "/users/info", {}, function (resp) {
            //
            //   if(resp && resp.data && resp.data.user){
            //     $(".user_coin").html(resp.data.user.coins);
            //     // $(".users_points").html(resp.data.user.points);
            //   }
            //
            // }, function () {
            //   Utils.hideWaitingLoader();
            // });

            // RECUPERO CATALOGO PREMI DA FANIZE

            // API.getOnFanize("campaigns/" + window.campaignId + "/catalog/rewards", {}, function (resp) {
            //
            //   // categorie podcat
            //   if(resp.data && resp.data.points && resp.data.points.length > 0) {
            //
            //     let template_catalogo = "";
            //
            //     $.each(resp.data.points, function (index, value) {
            //
            //       let tmp = window.templates["blocco_catalogo_premi"];
            //
            //       template_catalogo += tmp.replace("{{name}}", value.title)
            //         .replace("{{img_src}}", value.image)
            //         .replace("{{css_class}}", (index > 8?'hide_rewards':'show_rewards'))
            //         .replace("{{points}}", value.cost);
            //
            //     });
            //
            //     $("#lista_elementi_catalogo").html(template_catalogo).fadeIn(500);
            //
            //     if(resp.data.points.length > 8){
            //       $("#mostra_tutti_catalogo_container").show();
            //     }
            //
            //   } else{
            //     $("#podcast-categorie-utente").html("Non ci sono premi").fadeIn(500);
            //   }
            //
            // }, function () {
            //   Utils.hideWaitingLoader();
            // });

        }, function () {
          Utils.hideWaitingLoader();
          // router.addNavigation("/login");
        });

      // $(".tab-nav[data-section='#preferiti']").trigger("click");
    }

});



function populate_profile_fields(container, field){

    let field_label = field;

    if(!field){
        field = "";
    }

    if(!field_label){
        field_label = "-";
    }

    if(container == "blocco_dati_nascita") {
        if(field_label != "-") {
            $("#" + container + "_label").html(field_label.split("-").reverse().join("."));
        } else{
            $("#" + container + "_label").html("-");
        }
    } else{
        $("#" + container + "_label").html(field_label);
    }



    $("#" + container + "_input").val(field);

}


$(document).on('click','.profilo .tab-nav', (e)=>{
  const el=$(e.target);
  const link = el.attr('data-section');
  $('.tab-nav').removeClass('selected');
  el.addClass('selected');
  $('section').hide();
  $('section'+link).show();

  var url = link.replace("#", "");

  if(location.pathname.indexOf("/gioca") > -1){
    history.pushState({page: location.href}, "", "/gioca/"+url);
  } else{
    history.pushState({page: location.href}, "", "/profilo/"+url);

  }


  // }
  resumeAllSections();

});

$(document).on('click','#modifica_profilo', (e)=>{
    $("#dati .content_show").hide();
    $("#dati .hidden_input").show();
    $("#dati fieldset").addClass("fieldset_in_edit");
    $(".hobby-interessi-container").addClass("edit");
    $("#action_in_edit").show();
    $("#action_in_edit_bottom").show();
    $("#modifica_profilo").hide();
    $(".checkbox-dati-personali").show();
    $("input.checkbox-dati-personali").prop("disabled", false);
});

$(document).on('click','#indietro_modifica, #indietro_modifica_bottom', (e)=>{
    $("#dati .content_show").show();
    $("#dati .hidden_input").hide();
    $("#dati fieldset").removeClass("fieldset_in_edit");
    $(".hobby-interessi-container").removeClass("edit");
    $("#action_in_edit").hide();
    $("#action_in_edit_bottom").hide();
    $("#modifica_profilo").show();
   /* $(".checkbox-dati-personali").hide();*/
    $("input.checkbox-dati-personali").prop("disabled", true);

});

$(document).on('click','.choose_profilo.musica', (event)=>{

    if($(".fieldset-dati-nome").hasClass("fieldset_in_edit")) {
        $(".choose_profilo.musica").removeClass("selected");
        $(event.target).addClass("selected");
    }

});

$(document).on('click','.choose_profilo.interessi', (event)=>{

    if($(".fieldset-dati-nome").hasClass("fieldset_in_edit")) {
        $(".choose_profilo.interessi").removeClass("selected");
        $(event.target).addClass("selected");
    }

});

$(document).on('change','#file-change-avatar', (e)=>{

    user.changeAvatar();

});

$(document).on('click','.profilo_mostra_tutti', function(){

    var this_section = $(this).parents(".sezione-to-hide");
    $(".sezione-to-hide").not(this_section).hide();
    $(this).hide();
    $(this).parents(".container_single_profilo").find(".breadcrumb-to-show").addClass("show");
    $(this).parents(".container_single_profilo").find(".paginator_to_hide").hide();
    this_section.find(".sezione-to-show").addClass("show");
    $("html, body").animate({ scrollTop: 500 }, 0);

});

$(document).on('click','.click_to_resume', function(){

    resumeAllSections();

});

$(document).on('click','#modifica_password_div', function(){

    $("#modifica_password_blocco").show();
    $("#tab_menu_profilo").hide();
    $("#sezione_profilo_tab").hide();

});


function resumeAllSections(){
    $(".sezione-to-hide").show();
    $(".hide_in_dettaglio").show();
    $(".profilo_mostra_tutti").not(".fixed_hide").show();
    $(".breadcrumb-to-show").removeClass("show");
    $(".paginator_to_hide").show();
    $(".sezione-to-show").removeClass("show");
    $(".container_dettaglio_premio").remove();
}


function hideMostraAltri(paginatore){


    if($(paginatore).find("ul").children("li").length < 3){
        $(paginatore).parents(".sezione-to-hide").find(".profilo_mostra_tutti").addClass("fixed_hide");
    }
}




function populate_cronologia(user){

    $.ajax({
        type: 'GET',
        url: "https://0qo5sovlje.execute-api.eu-west-1.amazonaws.com/dev/view/user/" + user,
        dataType: 'json',
        'success': function(resp){

            var posts = resp.post;
            var podcasts = resp.podcast;
            var songs = resp.song;


            var template_post = "";

            if(posts){

                $.each(posts, function (index, post) {

                    let tmp = window.templates["blocco_post_visti"];
                    template_post += tmp.replaceAll("{{slug}}", post.additionalData.slug)
                        .replaceAll("{{image}}", post.additionalData.image)
                        .replaceAll("{{title}}", post.additionalData.title)
                        .replaceAll("{{category}}", post.additionalData.category)
                        .replaceAll("{{date}}", post.additionalData.date)
                });

                $("#profilo-articoli-letti").html(template_post);
                const breakpoints_post_let = [
                    {maxWidth: 550, perPage: 1},
                    {maxWidth: 750, perPage: 2},
                    {perPage: 3}
                ];

                new Paginator($('.pagination_post_letti'), {
                    total: posts.length,
                    breakpoints: breakpoints_post_let,
                    cssVar: '--cpl_paginator',
                    swipeElementSelector: '#profilo-articoli-letti'
                });
            } else{
                $("#profilo-articoli-letti").html(window.templates["empty_state_news"]);
            }

            hideMostraAltri(".pagination_post_letti");


            var template_podcast = "";

            if(podcasts) {

                    $.each(podcasts, function (index, podcast) {

                    let tmp = window.templates["blocco_podcast_ascoltati"];
                    template_podcast += tmp.replaceAll("{{element_id}}", podcast.id)
                        .replaceAll("{{ID}}", podcast.id)
                        .replaceAll("{{img_src}}", podcast.additionalData.immagine)
                        .replaceAll("{{category}}", podcast.additionalData.categoria)
                        .replaceAll("{{audio_src}}", podcast.additionalData.audioSrc)
                        .replaceAll("{{date}}", podcast.additionalData.giorno)
                        .replaceAll("{{post_title}}", podcast.additionalData.titolo)
                        .replaceAll("{{catSlug}}", podcast.additionalData.catSlug)
                        // .replaceAll("{{post_title}}", podcast.additionalData.slug)
                        .replaceAll("{{hide_in_cron}}","display:none;")
                });

                $("#blocco_podcast_ascoltati").html(template_podcast);

                const breakpoints_pod_asc = [
                    {maxWidth: 750, perPage: 1},
                    {perPage: 2}
                ];

                new Paginator($('.pagination_episodi_ascoltati'), {
                    total: podcasts.length,
                    breakpoints: breakpoints_pod_asc,
                    cssVar: '--cpa_paginator',
                    swipeElementSelector: '#blocco_podcast_ascoltati'
                });
            }else{
                $("#blocco_podcast_ascoltati").html(window.templates["empty_state_podcast_ascoltati"]);

            }

            hideMostraAltri(".pagination_episodi_ascoltati");

            var template_song = "";
            if(songs) {
                $.each(songs, function (index, song) {

                let tmp = window.templates["blocco_canzoni_utente"];
                template_song += tmp.replaceAll("{{data_id}}", song.id)
                    .replaceAll("{{track_id}}", song.id)
                    .replaceAll("{{song_mdbid}}", song.additionalData.master_id)
                    .replaceAll("{{song_title}}", song.additionalData.titolo)
                    .replaceAll("{{song_artist}}", song.additionalData.categoria)
                    .replaceAll("{{song_img}}", song.additionalData.immagine)
                    .replaceAll("{{hide_in_cron}}", "display:none;")
                });

                $("#blocco_songs_ascoltate").html(template_song);

                const breakpoints_canzoni_ascoltate = [
                    {maxWidth: 550, perPage: 2},
                    {maxWidth: 700, perPage: 3},
                    {maxWidth: 850, perPage: 4},
                    {maxWidth: 1000, perPage: 5},
                    {perPage: 6}
                ];

                new Paginator($('.pagination_canzoni_ascoltate'), {
                    total: songs.length,
                    breakpoints: breakpoints_canzoni_ascoltate,
                    cssVar: '--cca_paginator',
                    swipeElementSelector: '#blocco_songs_ascoltate'
                });
            }else{
                $("#blocco_songs_ascoltate").html(window.templates["empty_state_canzoni_ascoltate"]);

            }


            hideMostraAltri(".pagination_canzoni_ascoltate");


        },
        'error':function(err){
            console.log(err);
        }
    });
}




window.checkMoney= function(rewardId){


  // var haveMoney = false;
  // if(haveMoney == true){
  //   window.popUpRedimiPremio(rewardId);
  // } else{
  //   console.log("non hai money");
  // }

}
window.popUpRedimiPremio = function(rewardId){

  user.checkUser(function (_uu){

    API.get("community/getProvince", {}, (resp) => {

      if(resp.status == 1) {

        var popup_riscatta_premio = window.templates["popup_riscatta_premio"];

        $("#rds-main").append(popup_riscatta_premio);

        $("#user-riscatta-nome").val(_uu.nome);
        $("#user-riscatta-cognome").val(_uu.cognome);
        $("#user-riscatta-telefono").val(_uu.telefono);
        $("#user-riscatta-indirizzo").val(_uu.indirizzo);
        $("#user-riscatta-civico").val("");
        $("#user-riscatta-citta").val("");

        $.each(resp.province, function (i, item) {
          $('#user-riscatta-provincia').append($('<option>', {
            value: item.siglaprovincia,
            text : item.provincia
          }));
        });

        $("#user-riscatta-cap").val("");

        $("#rewardId").val(rewardId);

        $("html").css('overflow-y', 'hidden');

        $(document).on("click", ".x-delete", function () {
          $(".popup-errore-main").remove();
          $("html").css("overflow-y", 'auto');
        });

      }

    });


  }, function () {

    Utils.hideWaitingLoader();

  });

}

$(document).on("click", ".blocco_catalogo", function(event){

  var rewardId = $(event.currentTarget).data("rewardid");

  Utils.showWaitingLoader();


  API.get("site/dettaglioPremio", {id_fanize: rewardId}, (resp) => {

      var sezione_diversa = "";
        sezione_diversa = `<div id="sezione_non_loggato" style="display:none;">
                                <div class="color_blue font_16 semi_bold">Registrati e gioca per riscattare questo premio!</div>
                                <div class='popup-conferma-button flex' style="justify-content: left">
                                     <div id="registrati_riscatta" class='popup-conferma-close font_16 bold button skew uppercase' style="margin-top: 20px;">REGISTRATI</div>
                                </div>
                            </div>
                            <div id="sezione_loggato" style="display:none;">
                                <div class='popup-conferma-button flex' style="justify-content: left">
                                     <div id="riscatta_premio" class='popup-conferma-close font_16 bold button skew uppercase' style="margin-top: 20px;">RISCATTA ORA</div>
                                </div>
                            </div>
                            <div id="sezione_no_money" style="display:none;">
                                <div class="color_blue font_16 semi_bold">Ancora <span id="num_diff_premio"></span> coins per poter riscattare questo premio!</div>
                                <div class='popup-conferma-button flex' style="justify-content: left">
                                     <a href="/gioca"><div id="" class='popup-conferma-close font_16 bold button skew uppercase' style="margin-top: 20px;">GIOCA ANCORA</div></a>
                                </div>
                            </div>`;

      var premio = resp.reward;
      var user_fanize;
      if(resp.userFanize.data){
        user_fanize = resp.userFanize.data.user;
      }

      $("#catalogo").find(".hide_in_dettaglio").hide();
      $("#catalogo").append(`<div class="container_dettaglio_premio">
                                <div class="h-padded-container tablet_padding breadcrumb_container breadcrumb-to-show show">
                                  <div class="flex align_center font_18 semi_bold torna_catalogo">
                                      <img class="breadcrumb_arrow" src="https://media.rds.it/web/web-site-brandnew/svg/path-copy-3.svg">
                                       <a class="color_blue">Torna a &nbsp;</a>
                                       <a class="color_blue">Catalogo</a>
                                   </div>
                                </div>
                                <div class=" h-padded-container tablet_padding" style="padding-bottom: 80px;">
                                  <div class="flex justify_between container_info_premio_dettaglio">
                                    <div class="cont_imma_premio"><img src="${premio.img_src}"></div>
                                    <div class="cont_info_premio">
                                        <div class="flex align_center"><span class="color_blue font_22 font_18_tablet semi_bold" style="margin-right: 7px;">${premio.cost}</span><img style="width: 21px; margin-right: 5px;" src="https://media.rds.it/web/web-site-brandnew/svg/icon-star.svg"></div>
                                        <div class="dark_font font_36 semi_bold sofia_font">${premio.title}</div>
                                        <div class="dark_font font_18 sofia_font">${premio.description}</div>
                                        <div style="margin-top: 20px;">${sezione_diversa}</div>
                                    </div>
                                  </div>
                              </div>
                              </div>`);

        if (user.checkUser()) {
          if(premio.cost_type == "points" && premio.cost > user_fanize.points ){
            var diff = premio.cost - user_fanize.points;
            $("#num_diff_premio").text(diff + " punti ");
            $("#sezione_no_money").show();
          } else if(premio.cost_type == "coins" && premio.cost > user_fanize.coins){
            var diff = premio.cost - user_fanize.coins;
            $("#num_diff_premio").text(diff + " punti ");
            $("#sezione_no_money").show();
          }else{
            $("#sezione_loggato").show();
          }
        } else {
          $("#sezione_non_loggato").show();
        }

      $('#registrati_riscatta').off().click(function() {

        user.openPopupLoginAndCallback(replaceNavigation, ["/gioca/catalogo"]);

      });
      $('#riscatta_premio').off().click(function() {

        window.popUpRedimiPremio(rewardId);


      });
      Utils.hideWaitingLoader();

  });




});
$(document).on("click", ".torna_catalogo", function(event){

  $(".container_dettaglio_premio").remove();
  $("#catalogo").find(".hide_in_dettaglio").show();


});


///// pulsante interna premio da creare
$(document).on("click", ".riscatta_premio", function(event){

  var rewardId = $(event.currentTarget).data("rewardid");

  if (user.checkUser()) {
    window.popUpRedimiPremio(rewardId);
  } else {
    user.openPopupLoginAndCallback("window.popUpRedimiPremio", [rewardId]);
  }


});

// $(document).on("click", "a.gioco_online", function(event){
//
//   // se non sono loggato, allora mostro il popup di login e successivamente vado nella pagina
//
//   if (!user.checkUser()) {
//     event.preventDefault();
//     user.openLoginPopupGame(event.currentTarget.href);
//   }
//
// });



